import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, Button, Popconfirm, Icon, Divider, Input } from 'antd';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Highlighter from 'react-highlight-words';
// import * as actions from './src/store/actions/auth.js';


const API_HOST_URL = process.env.REACT_APP_API_URL

class Employee extends Component{

  state = {
    employees: [],
    searchText: ''
  }

  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        .toString()
        .toLowerCase()
        .includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: text => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text.toString()}
      />
    ),
  });

  handleSearch = (selectedKeys, confirm) => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: '' });
  };

  columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      render: (id) => <Link to={`employee/${id}`}>{id}</Link>,
    },
    {
      title: 'Employee Code',
      dataIndex: 'employeeCode',
      key: 'employeeCode',
      ...this.getColumnSearchProps('employeeCode'),
    },
    {
      title: 'First Name',
      dataIndex: 'firstName',
      key: 'firstName',
      ...this.getColumnSearchProps('firstName'),
    }, {
      title: 'Last Name',
      dataIndex: 'lastName',
      key: 'lastName',
      ...this.getColumnSearchProps('lastName'),
    },
    {
      title: 'Job Title',
      dataIndex: 'jobTitle.jobTitle',
      key: 'jobTitle',
    },
    {
      title: 'Department',
      dataIndex: 'department.department',
      key: 'department',
    },
    {
      title: 'Action',
      key: 'action',
      fixed: 'right',
      width: 100,
      render: (record) => (
        <span>
        <a href="javascript:;" onClick={() => this.handleEdit(record)}><Icon type="edit" /></a>
  
        <Divider type="vertical" />
  
        {this.state.employees.length >= 1
          ? (
            <Popconfirm title="Sure to delete?" onConfirm={() => this.handleDelete(record)}>
              <a href="javascript:;"><Icon type="delete" /></a>
            </Popconfirm>
          ) : null}
          </span>
      ),
  
    }];
    

  handleEdit = record => {
    // this.setState({division: record});
    // this.showModal('put');
}

handleDelete = (record) => {
  // const datalist = [...this.state.datalist];

  return axios.delete(`${API_HOST_URL}/api/employee/employee/${record.id}/`)
              .then(res => {
                console.log(res)

                // this.setState({ visible: false });
                this.fetchData()
                // this.props.history.push("/employee");
          })
              .catch(error => console.err(error));
}
   
  componentDidMount(){
      this.fetchData();
  }

  fetchData(){
    axios.get(`${API_HOST_URL}/api/employee/employee/?expand=department&expand=jobTitle`)
      .then(res => {
        this.setState({
          employees: res.data
        })
        console.log(res.data);
      })
  }

    render(){
        return(
          <div>
            {
              this.props.userPermissions.indexOf('add_employee') > -1 ? 
            <Link to="/employee/new">Add Employee</Link>
            : ''
            }

            {
              this.props.userPermissions.indexOf('view_employee') > -1 ?
            <Table columns={this.columns} dataSource={this.state.employees} rowKey="id" scroll={{ x: '100%' }}/>
            : 'You do not have rights to view Employees. Please Contact your Administrator'
            }
          </div>
            
        );
    }
}

const mapStateToProps = state => {
  return {
    isAuthenticated: state.token !== null,
    userPermissions: state.userPermissions
  }
}

export default connect(mapStateToProps, null)(Employee);
// export default Employee;